module.exports = __webpack_public_path__ + "static/media/golfer-2-b.d9d52fe2.png";